import { axiosClient } from "../api-client";

// type Prop = {
// 	config?: AxiosRequestConfig;
// 	body?: any;
// 	param?: string;
// };

export function GetUsers({ config, body }) {
	return axiosClient.get("/v1/admin/user/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetExperienceList({ config, body }) {
	return axiosClient.get("/v1/admin/nfts/experience/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function PatchListToToken({ config, body }) {
	const body_ = { ...body };
	const id = body_._id;
	delete body_._id;
	return axiosClient.patch(`/v1/admin/nfts/${id}/onsale`, body_, config);
}

export function GetAdminUsers({ config }) {
	return axiosClient.get("/v1/admin/superusers", config);
}

export function GetDashCount({ config }) {
	return axiosClient.get("/v1/dashcounts", config);
}

export function UploadImage({ config, body }) {
	return axiosClient.post("/v1/image", body, config);
}

export function AddCategory({ config, body }) {
	return axiosClient.post("/v1/category", body, config);
}

export function GetCategories({ config }) {
	return axiosClient.get("/v1/category", config);
}

export function GetCategoriesSimple({ config }) {
	return axiosClient.get("/v1/category/list/simple", config);
}

export function EditCategory({ config, body }) {
	const id = body._id;
	delete body._id;
	return axiosClient.patch("/v1/category/" + id, body, config);
}

export function DeleteCategory({ config, body }) {
	return axiosClient.delete("/v1/category/" + body, config);
}

export function AddBanner({ config, body }) {
	return axiosClient.post("/v1/banner", body, config);
}
export function EditBanner({ config, body }) {
	const id = body._id;
	delete body._id;
	return axiosClient.patch("/v1/banner/" + id, body, config);
}

export function PatchExperience({ config, body }) {
	return axiosClient.patch(
		"/v1/admin/nfts/experience",
		{},
		{
			...config,
			params: {
				...config.params,
				...body,
			},
		}
	);
}

export function SecretExperience({ config, body }) {
	return axiosClient.post("/v1/admin/nfts/experience/secret", body, config);
}

export function SecretExperienceCode({ config, body }) {
	return axiosClient.post(
		"/v1/admin/nfts/experience/redeemtioncode",
		body,
		config
	);
}

export function PatchExperienceCancel({ config, body }) {
	return axiosClient.patch(
		"/v1/admin/nfts/experience/canceled",
		{},
		{
			...config,
			params: {
				...config.params,
				...body,
			},
		}
	);
}

export function DeleteBanner({ config, body }) {
	return axiosClient.delete("/v1/banner/" + body, config);
}

export function GetBanner({ config }) {
	return axiosClient.get("/v1/banner", config);
}

export function GetRedeemList({ config, body }) {
	return axiosClient.get("/v1/admin/nfts/redeem/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetRedeemListUser({ config, body }) {
	return axiosClient.get("/v1/admin/nfts/redeem/list/" + body, config);
}

export function RollBack({ body, config }) {
	return axiosClient.post("/v1/dummy-data/" + body, {}, config);
}
